import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import token from './token'
import params from './params'
import dailyPath from './dailyPath'
import message from './message'
import isPrivate from './isPrivate'
import policyParams from './policyParams'
import scroll from './scroll'
import home from './home'
import objjobhunterinfo from './objjobhunterinfo'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    token,
    params,
    dailyPath,
    message,
    isPrivate,
    policyParams,
    home,
    scroll,
    objjobhunterinfo
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js